import { render, staticRenderFns } from "./partyGroupConfigEdit.vue?vue&type=template&id=05ca6a26&scoped=true"
import script from "./partyGroupConfigEdit.vue?vue&type=script&lang=js"
export * from "./partyGroupConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./partyGroupConfigEdit.vue?vue&type=style&index=0&id=05ca6a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca6a26",
  null
  
)

export default component.exports